interface AppErrorOptions {
  type?: string;
  feedback?: string;
  code?: string;
  origin?: Error;
}

export class PlacesApiError extends Error {
  public readonly type?: string;

  public readonly feedback?: string;

  public readonly code?: string;

  public readonly origin?: Error;

  constructor(message?: string, options?: AppErrorOptions) {
    super(message || 'An error occurred in the Places Service');

    this.name = 'PlacesServiceError';
    this.type = options?.type;
    this.feedback = options?.feedback;
    this.code = options?.code;
    this.origin = options?.origin;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, PlacesApiError);
    }
  }
}
